import { Wallet, Smartphone, Banknote, CreditCard } from "lucide-react";

export const PAYMENT_METHODS = [
  {
    key: "esewa",
    label: "eSewa",
    icon: Wallet,
    color: "#16A34A",
  },
  {
    key: "khalti",
    label: "Khalti",
    icon: Smartphone,
    color: "#9333EA",
  },
  {
    key: "cod",
    label: "Cash",
    icon: Banknote,
    color: "#F59E0B",
  },
  {
    key: "wallet",
    label: "Wallet",
    icon: Wallet,
    color: "#EC4899",
  },
];
